module.exports = __webpack_public_path__ + "static/media/256x256.f1bf0c0a.gif";